@for (uiConfig of popoverData.uiConfigs; track $index) {
  <div>
    <ng-container *ngComponentOutlet="uiConfig.ui.type; inputs: getInputs(uiConfig); injector: injector()" />
  </div>
}
